<template>
  <div class="game-platform-list">
    <header class="header">
      <div class="back-button" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <h1 class="title">{{ platformName }}</h1>
    </header>

    <div class="tab-container">
      <div 
        class="tab-item" 
        :class="{ active: activeTab === 'all' }" 
        @click="switchTab('all')"
      >
        全部({{ allGames.length }})
      </div>
      <div 
        class="tab-item" 
        :class="{ active: activeTab === 'recommended' }" 
        @click="switchTab('recommended')"
      >
        推荐({{ recommendedGames.length }})
      </div>
    </div>

    <div class="games-container">
      <div v-if="loading" class="loading">
        <div class="spinner"></div>
        <p>加载中...</p>
      </div>

      <div v-else-if="displayGames.length === 0" class="no-games">
        暂无游戏
      </div>
      
      <div v-else class="game-list">
        <div 
          v-for="game in displayGames" 
          :key="game.id" 
          class="game-card"
          @click="openGame(game)"
        >
          <img class="game-image" :src="getImageUrl(game.mobile_img)" :alt="game.name" />
          <div class="game-info">
            <div class="game-name">{{ game.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiFun from "@/http/api.js";

export default {
  name: 'GameList',
  data() {
    return {
      platformId: '',
      gameTypeId: '',
      platformName: '',
      allGames: [], // 存储所有游戏数据
      loading: true,
      activeTab: 'all'
    };
  },
  computed: {
    // 根据is_recommend过滤推荐游戏
    recommendedGames() {
      return this.allGames.filter(game => game.is_recommend === 1);
    },
    // 根据当前标签显示不同的游戏列表
    displayGames() {
      return this.activeTab === 'all' ? this.allGames : this.recommendedGames;
    }
  },
  created() {
    // 从路由参数获取平台ID和游戏类型ID
    // 优先使用query参数，这是从首页传递过来的
    this.platformId = this.$route.query.platform || this.$route.params.platformId;
    this.gameTypeId = this.$route.query.game_type_list_id || this.$route.params.gameTypeId;
    
    // 设置默认标题，使用平台ID大写作为标题
    this.setPlatformName();
    
    console.log('接收到的参数:', {
      platform: this.platformId,
      game_type_list_id: this.gameTypeId,
      game_code: this.$route.query.game_code
    });
    
    this.loadGames();
  },
  methods: {
    // 设置平台名称
    setPlatformName() {
      // 优先使用查询参数中的platform_name
      if (this.$route.query.platform_name) {
        this.platformName = this.$route.query.platform_name;
      } 
      // 否则使用平台ID转大写 + "电子"
      else if (this.platformId) {
        this.platformName = this.platformId.toUpperCase() + "电子";
      } 
      // 默认名称
      else {
        this.platformName = '游戏列表';
      }
    },
    switchTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab;
        // 不再需要重新加载数据，只需切换视图
      }
    },
    async loadGames() {
      this.loading = true;
      try {
        const params = {
          platform: this.platformId,
          game_type_list_id: this.gameTypeId,
          game_code: this.$route.query.game_code
        };
        
        console.log('加载游戏列表，参数：', params);
        
        const response = await apiFun.post('/api/game/list', params);
        
        if (response && response.code === 200) {
          console.log('获取游戏列表成功:', response.data);
          this.allGames = response.data.games || response.data || [];
        } else {
          console.error('获取游戏列表失败:', response);
          this.allGames = [];
        }
      } catch (error) {
        console.error('获取游戏列表失败:', error);
        this.allGames = [];
      } finally {
        this.loading = false;
      }
    },
    getImageUrl(relativePath) {
      if (!relativePath) return '';
      if (relativePath.startsWith('http')) return relativePath;
      return '/storage/' + relativePath.replace(/^\/+/, '');
    },
    openGame(game) {
      console.log('点击游戏:', game);
      // 传递game_type_list_id和game.game_code参数
      // 第一个参数是game_type_list_id（当前页面的gameTypeId），不是game.id
      this.$parent.openGamePage(game.name, this.gameTypeId, game.game_code || '');
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.game-platform-list {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8f8;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  z-index: 10;
  position: relative;
}

.back-button {
  position: absolute;
  left: 15px;
  font-size: 16px;
  cursor: pointer;
  color: #333;
  display: flex;
  align-items: center;
}

.back-button i {
  margin-right: 4px;
}

.title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  text-align: center;
}

.tab-container {
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  font-size: 14px;
  color: #999;
  position: relative;
}

.tab-item.active {
  color: #cf866b;
  font-weight: 500;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 2px;
  background-color: #cf866b;
}

.games-container {
  padding: 15px;
  flex: 1;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #cf866b;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.no-games {
  text-align: center;
  padding: 50px;
  color: #999;
}

.game-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.game-card {
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
}

.game-card:active {
  transform: scale(0.98);
}

.game-image {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
}

.game-info {
  padding: 8px 10px;
  text-align: center;
}

.game-name {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style> 


// WEBPACK FOOTER //
// src/pages/GameList.vue